import GetScript from './GetScript.js';
import { environment } from './environment.js';

let client = null;
let openSubscriptions = {};
let isShared = false;

export class LightStreamerSubscription {
    static subscribe(_epic, modifier = '', container, onChange, index = 0) {
        let epicValues = 'V2-F-BID,OFR,CPT,CPC,HIG,LOW,UTM,SWAP_1_SHORT,SWAP_1_LONG,SCALING_FACTOR,SWAP_8_LONG,SWAP_8_SHORT';
        if (modifier.toUpperCase().includes('PUBLIC')) {
            epicValues += ',AUTO_QUALITY';
        }
        const epic = `${epicValues + modifier}|${_epic}|1`;
        const schema = epic.split('|')[0].match(/\w{3,}/g);
        const subscription = new window.Lightstreamer.Subscription('MERGE', epic, [].concat(schema));
        subscription.addListener(LightStreamerSubscription.subscriptionListener(container, onChange, index));
        subscription.setRequestedMaxFrequency(1);
        LightStreamerSubscription.client.subscribe(subscription);
        openSubscriptions[_epic] = subscription;
    }

    static subscriptionListener(container, onChange, index) {
        return {
            onItemUpdate(itemUpdate) {
                itemUpdate.forEachChangedField((fieldName, fieldPos, newValue) => {
                    onChange(container, fieldName, fieldPos, newValue, index);
                });
            },
        }
    }

    static unsubscribe(epic) {
        LightStreamerSubscription.client.unsubscribe(openSubscriptions[epic]);
    }

    static get client() { return client; }

    static set client(_client) { client = _client; }

    static domain(hostname = window.location.hostname) {
        switch (environment(hostname)) {
            case 'net':
                return 'net-';
            case 'web':
                return 'web-';
            default:
                return '';
        }
    }

    static connect() {
        client = new window.Lightstreamer.LightstreamerClient(`https://${LightStreamerSubscription.domain()}upp.ig.com`, 'InVisionProvider');
        client.connectionSharing.enableSharing('uppProvider', 'ATTACH', isShared ? 'WAIT' : 'CREATE');
        client.connect();
        isShared = true;
    }

    static loadScript(setup) {
        if (typeof window.Lightstreamer !== 'undefined' && window.Lightstreamer.version === '7.2.0') {
            LightStreamerSubscription.connect();
            setup();
        } else {
            GetScript.JS('https://a.c-dn.net/b/0LXEfQ.js#ig-fe-login-lightstreamer.7.2.0.min.js')
                .then(() => {
                    LightStreamerSubscription.connect();
                    setup();
                })
                .catch(() => {
                    console.error('lightstreamer.7.2.0.min.js Failed to load!');
                });
        }
    }
}
